import VimeoPlayer from "@vimeo/player";
import { prefersReducedMotion } from "../../Shared/Utilities/userPreferences";

const hero = document.querySelector<HTMLElement>("#home-page-hero");

if (hero) {
  const videoIframe = hero.querySelector<HTMLIFrameElement>("#home-page-hero-video");

  if (videoIframe?.dataset.src && !prefersReducedMotion()) {
    videoIframe.src = videoIframe.dataset.src;

    const videoPlayer = new VimeoPlayer(videoIframe);
    const videoStatus = hero.querySelector<HTMLElement>("[data-js-video-status]");
    const image = videoIframe.closest<HTMLDivElement>("[data-video-loaded]");

    const updateVideoStatus = (isPlaying: boolean) => {
      if (videoStatus) {
        videoStatus.textContent = isPlaying
          ? videoStatus.dataset.playingText || "Video playing"
          : videoStatus.dataset.pausedText || "Video paused";
      }
    };

    videoPlayer.on("play", () => {
      videoIframe.ariaHidden = "false";
      updateVideoStatus(true);

      if (image) {
        image.dataset.videoLoaded = "true";
      }
    });

    videoPlayer.on("pause", () => {
      updateVideoStatus(false);
    });

    const playPauseButton = hero.querySelector<HTMLButtonElement>(
      "[data-js-play-pause-button]"
    );

    if (playPauseButton) {
      playPauseButton.addEventListener("click", () => {
        const playIcon = playPauseButton.querySelector<HTMLElement>(
          "[data-js-symbol-name='play']"
        );
        const pauseIcon = playPauseButton.querySelector<HTMLElement>(
          "[data-js-symbol-name='pause']"
        );

        if (playIcon && pauseIcon) {
          playIcon.classList.toggle("hidden");
          pauseIcon.classList.toggle("hidden");

          videoPlayer.getPaused().then(paused => {
            if (paused) {
              playPauseButton.ariaPressed = "true";
              videoPlayer.play();
            } else {
              playPauseButton.ariaPressed = "false";
              videoPlayer.pause();
            }
          });
        }
      });
    }
  }
}
